/**
 * The micro-label is the spine of the design: counters, nav links, section
 * marks, table headings, footer. Reuse these rather than retyping the values.
 */
export const MICRO = 'text-[11px] uppercase tracking-[0.24em] leading-none'

export const MICRO_FAINT = `${MICRO} text-fz-faint`

/** power3.out — every hover and reveal on the site uses it. */
export const EASE = 'cubic-bezier(0.215, 0.61, 0.355, 1)'

export const EASE_CLASS = 'ease-[cubic-bezier(0.215,0.61,0.355,1)]'
